import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatSectionHeader = createCustomElementWrapper('kat-section-header', 'KatSectionHeader', {
    'actionIcon': 'action-icon',
    'actionLabel': 'action-label',
    'statusType': 'status-type',
}, {
    'onAction': 'action',
    'onCollapse': 'collapse',
    'onExpand': 'expand',
});
